import tw from "twin.macro";
import styled from "styled-components";

export const Content = styled.section(tw`w-full lg:w-3/4 p-8 py-9`);
export const LeftContent = styled(Content)(tw`lg:float-right`);
export const Column = styled.div(tw`w-full lg:w-1/2 h-full px-6 lg:px-4`);
